export const handleMaritalStatusOptions = (form: any, gender: string) => {
  const maritalStatus = form.getFieldValue("marital_status");

  if (!gender || !maritalStatus) return;

  if (gender === "Masculino") {
    const value = maritalStatus.toLowerCase().includes("solt")
      ? "Soltero"
      : "Casado";
    form.setFieldValue("marital_status", value);
  }
  if (gender === "Femenino") {
    const value = maritalStatus.toLowerCase().includes("solt")
      ? "Soltera"
      : "Casada";
    form.setFieldValue("marital_status", value);
  }
};
